// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fenge[data-v-265e8c0a]{height:30px;margin-top:20px}.fenge[data-v-265e8c0a],.footer[data-v-265e8c0a]{background-color:#333;clear:both}.footer[data-v-265e8c0a]{padding:.5rem 0}.footer .footerBox[data-v-265e8c0a]{width:24rem;margin:0 auto;color:#d2d2d2;font-size:1rem;line-height:1.5rem}.footer .footerBox span[data-v-265e8c0a]{margin-right:1.5rem}", ""]);
// Exports
module.exports = exports;
